// extracted by mini-css-extract-plugin
export default {"imprint":"Imprint_imprint__giUQu","logo":"Imprint_logo__XZ8iH","block":"Imprint_block__V3IMU","title":"Imprint_title__2h5WI","info":"Imprint_info__YQK8d"};